























































import { Component, Mixins, Prop, } from "vue-property-decorator";
import { IAiIfSyntax } from "../../../../../domain/externalSystem";
import { AiSyntaxMixin } from "../../mixins";
import { SyntaxEditorMixin } from "./mixins";

@Component
export default class AiSyntaxIfEditor extends Mixins(AiSyntaxMixin, SyntaxEditorMixin) {
  writePropertyWhenValid: (writer: (source: IAiIfSyntax) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IAiIfSyntax) => T, defaultValue: T) => T;

  $refs!: {
    templateInput: HTMLInputElement,
    elseTemplateInput: HTMLInputElement,
  };

  @Prop()
  editSyntax: (defaultKeyword: string) => Promise<string>;

  get condition(): string {
    return this.readPropertyOrDefault(s => s.condition, null);
  }

  set condition(value: string) {
    this.writePropertyWhenValid(s => s.condition = value);
    this.$nextTick(() => this.updateSource());
  }

  get template(): string {
    return this.readPropertyOrDefault(s => s.template, null);
  }

  set template(value: string) {
    this.writePropertyWhenValid(s => s.template = value);
    this.$nextTick(() => this.updateSource());
  }

  get isElseEnable(): boolean {
    return this.readPropertyOrDefault(s => s.isElseEnable, null);
  }

  set isElseEnable(value: boolean) {
    this.writePropertyWhenValid(s => s.isElseEnable = value);
    this.$nextTick(() => this.updateSource());
  }

  get elseTemplate(): string {
    return this.readPropertyOrDefault(s => s.elseTemplate, null);
  }

  set elseTemplate(value: string) {
    this.writePropertyWhenValid(s => s.elseTemplate = value);
    this.$nextTick(() => this.updateSource());
  }

  get isSyntaxValid(): boolean {
    return !!this.condition
      && this.template
      && (!this.isElseEnable || (this.isElseEnable && !!this.elseTemplate));
  }

  get conditionStyle(): any {
    return {
      backgroundColor: this.shouldInputCondition ? this.noticeIndicationBackgroundColor : null,

      // IE用の指定
      // placeholderの文字色はCSS変数(--placeholder-color)を使って指定しているがIEでは使えない
      // IEはinputで指定した文字色がplaceholderの文字色になっているため残している
      color: this.shouldInputCondition ? this.noticeIndicationColor : null,
    };
  }

  get shouldInputCondition(): boolean {
    return !this.condition;
  }

  get templateStyle(): any {
    return {
      backgroundColor: this.shouldInputTemplate ? this.noticeIndicationBackgroundColor : null,

      // IE用の指定
      // placeholderの文字色はCSS変数(--placeholder-color)を使って指定しているがIEでは使えない
      // IEはinputで指定した文字色がplaceholderの文字色になっているため残している
      color: this.shouldInputTemplate ? this.noticeIndicationColor : null,
    };
  }

  get shouldInputTemplate(): boolean {
    return !this.template;
  }

  get elseTemplateStyle(): any {
    return {
      backgroundColor: this.shouldInputElseTemplate ? this.noticeIndicationBackgroundColor : null,

      // IE用の指定
      // placeholderの文字色はCSS変数(--placeholder-color)を使って指定しているがIEでは使えない
      // IEはinputで指定した文字色がplaceholderの文字色になっているため残している
      color: this.shouldInputElseTemplate ? this.noticeIndicationColor : null,
    };
  }

  get shouldInputElseTemplate(): boolean {
    return this.isElseEnable && !this.elseTemplate;
  }

  createSyntax(): string {
    return "{ if { " + this.condition + " } ? { " + this.template + " } "
      + (this.isElseEnable ? "else ? { " + this.elseTemplate + " } " : "")
      + "}";
  }

  updateSource(): void {
    this.writePropertyWhenValid(s => {
      s.value = this.createSyntax();
      s.isValid = this.isSyntaxValid;
    });
  }

  async insertSyntaxInTemplate(isDnd: boolean): Promise<void> {
    const selectionStart = this.$refs.templateInput.selectionStart;
    const selectionEnd = this.$refs.templateInput.selectionEnd;
    const defaultKeyword = isDnd ? "" : this.template.substring(selectionStart, selectionEnd);

    const syntax = await this.editSyntax(defaultKeyword);
    if (syntax || (!syntax && !defaultKeyword)) {
      this.template = this.mergeTemplate(this.template, syntax, selectionStart, selectionEnd);
    }

    this.$nextTick(() => {
      this.$refs.templateInput.setSelectionRange(selectionStart, selectionStart + syntax.length);
      this.$refs.templateInput.focus(); // setSelectionRangeより前に実行するとIEで選択した構文が空になるので注意
    });
  }

  async insertSyntaxInElseTemplate(isDnd: boolean): Promise<void> {
    const selectionStart = this.$refs.elseTemplateInput.selectionStart;
    const selectionEnd = this.$refs.elseTemplateInput.selectionEnd;
    const defaultKeyword = isDnd ? "" : this.elseTemplate.substring(selectionStart, selectionEnd);

    const syntax = await this.editSyntax(defaultKeyword);
    if (syntax || (!syntax && !defaultKeyword)) {
      this.elseTemplate = this.mergeTemplate(this.elseTemplate, syntax, selectionStart, selectionEnd);
    }

    this.$nextTick(() => {
      this.$refs.elseTemplateInput.setSelectionRange(selectionStart, selectionStart + syntax.length);
      this.$refs.elseTemplateInput.focus(); // setSelectionRangeより前に実行するとIEで選択した構文が空になるので注意
    });
  }

  mergeTemplate(source: string, extraSource: string, selectionStart: number, selectionEnd: number): string {
    const index = (selectionStart !== undefined) ? selectionStart : source.length;
    return source.slice(0, index) + extraSource + source.slice(Math.max(index, selectionEnd));
  }

  onTemplateDragOver(event: DragEvent): void {
    event.stopPropagation();
    // キャレットを出したいのと貼り付けはtextareaのデフォルトアクションで行いたいのでpreventDefault()は呼ばない
    event.dataTransfer.dropEffect = "copy";
  }

  onTemplateInputDropped(event: DragEvent): void {
    event.stopPropagation();
    // ドロップした位置にテキストを挿入してからEmitする
    window.setTimeout(() => {
      this.insertSyntaxInTemplate(true);
    });
  }

  async onElseTemplateInputDropped(event: DragEvent): Promise<void> {
    event.stopPropagation();
    // ドロップした位置にテキストを挿入してからEmitする
    window.setTimeout(() => {
      this.insertSyntaxInElseTemplate(true);
    });
  }
}
